import { useContext } from 'react';
import ErrorContext from 'App/error/ErrorContext';

export const useErrorHandler = () => {
  return useContext(ErrorContext);
};
